import { useMutation, useQueryClient } from 'react-query'
import { toast } from 'react-toastify'
import { axios } from '../../../lib'

export const deleteMaxMatDiscByGroup = (
  discountMaxValueId: string
): Promise<{ data: any; total: number }> => {
  return axios.delete(
    `/parameters/discount-max-mat-group/${discountMaxValueId}`
  )
}

export function useDeleteMaxMatDiscByGroup() {
  const queryClient = useQueryClient()

  return useMutation(deleteMaxMatDiscByGroup, {
    onSuccess: () => {
      queryClient.invalidateQueries('maximumMaterialDiscountByGroup')
      toast.success('Valor de alçada de desconto excluído com sucesso!')
    },
    onError: (error: unknown) => {
      console.error(error)
      toast.error('Não foi possível excluir valor de alçada de desconto!')
    }
  })
}
